import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef } from "react";

// 次話遷移カウントダウン15秒
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const nextEpisodeDuration = 15000;
const checkFullScreen = () => {
  const fullScreenClass = document.getElementsByClassName("vjs-fullscreen");
  // fullscreenが有効な場合
  if (window.innerHeight == screen.height || fullScreenClass && fullScreenClass.length > 0) {
    return true;
  } else {
    return false;
  }
};
function ProgressCircle() {
  const circle = useRef();
  useEffect(() => {
    if (circle.current) {
      circle.current.style["stroke-dashoffset"] = 0;
    }
  }, [circle.current]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.progressCircle,
    children: /*#__PURE__*/_jsxs("svg", {
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("circle", {
        r: "45",
        cx: "50",
        cy: "50",
        fill: "transparent",
        strokeDasharray: "282.6",
        strokeDashoffset: "0",
        strokeOpacity: "0.5"
      }), /*#__PURE__*/_jsx("circle", {
        ref: circle,
        r: "45",
        cx: "50",
        cy: "50",
        fill: "transparent",
        strokeDasharray: "282.6",
        strokeDashoffset: "0"
      })]
    })
  });
}
export default function NextEpisode(_ref) {
  let {
    watch,
    state
  } = _ref;
  const imageStyles = {
    borderRadius: "8px"
  };
  const {
    nextEpisode
  } = watch;
  const router = useRouter();
  const handleCancel = useCallback(() => {
    state.prepareSuspend();
  }, []);
  const isFullScreen = checkFullScreen();
  const pageTransition = useCallback(() => {
    if (!isFullScreen) {
      window.location.replace(routes.watch(nextEpisode.id));
    } else {
      router.replace(routes.watch(nextEpisode.id));
    }
  }, [isFullScreen]);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      pageTransition();
    }, nextEpisodeDuration);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.nextEpisode,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          onClick: pageTransition,
          children: "\u6B21\u306E\u30A8\u30D4\u30BD\u30FC\u30C9\u3092\u898B\u308B"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.episode,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.episode,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.artwork,
            children: !!(nextEpisode !== null && nextEpisode !== void 0 && nextEpisode.thumbnailUrl) && /*#__PURE__*/_jsx(Image, {
              src: nextEpisode === null || nextEpisode === void 0 ? void 0 : nextEpisode.thumbnailUrl,
              alt: nextEpisode === null || nextEpisode === void 0 ? void 0 : nextEpisode.name,
              width: 160,
              height: 90,
              layout: "responsive",
              style: imageStyles
            })
          })
        }), /*#__PURE__*/_jsx(ProgressCircle, {})]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: /*#__PURE__*/_jsx("span", {
          children: nextEpisode === null || nextEpisode === void 0 ? void 0 : nextEpisode.name
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          className: styles.cancel,
          onClick: handleCancel,
          children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
        })
      })]
    })
  });
}